import extractWord from "./extractWord";
import extractSample from "./extractSample";

export default {
  word: extractWord,
  sample: extractSample,
};
